import React from 'react';
import { styled } from "../../../stitches.config";
import Box from '../Box'
import { Wrapper } from "./ACommonStyles";
import { getPcsUrls } from "./AHelpers";

export default props => {
	const pcs = getPcsUrls(props.settings.settings?.pcs_background_mobile, props.settings.settings?.pcs_background_desktop);
	const isBackgroundMode = props.blockGroupHasBackground;
	const blockColorBackground = props.blockColorBackground;
	const isDarkMode = props.isDarkMode;

	console.log("Kolor tła: ")
	console.log(blockColorBackground)

	return (
		<section className="container" data-is-dark-mode={isBackgroundMode} data-tb-region={props.blockSettings.tb_region}>
			<Wrapper className="row" pcs={pcs}>
				<WrapperTextOnPicture className="col-xs-12 col-md-8">
					<Box {...props}
						id="b1"
						type="BTextOnPicture"
						settings={props.settings.b1}
						imageHeight={(window.innerWidth > 991 ? 472 : 218)}
					/>
				</WrapperTextOnPicture>
				<WrapperList className="col-xs-12 col-md-4" isDarkMode={isBackgroundMode}>
					<Box {...props} id="b2" type="BPhotoOnLeft" settings={props.settings.b2} isDarkMode={isBackgroundMode} />
					<Box {...props} id="b3" type="BPhotoOnLeft" settings={props.settings.b3} isDarkMode={isBackgroundMode} />
					<Box {...props} id="b4" type="BPhotoOnLeft" settings={props.settings.b4} isDarkMode={isBackgroundMode} />
					<Box {...props} id="b5" type="BPhotoOnLeft" settings={props.settings.b5} isDarkMode={isBackgroundMode} />
					<Box {...props} id="b6" type="BPhotoOnLeft" settings={props.settings.b6} isDarkMode={isBackgroundMode} />
					<LinkSeeAll blockColorBackground={blockColorBackground} isDarkMode={isBackgroundMode}>
						{/*<a href="">Zobacz więcej</a>*/}
						<Box {...props} id="b7" type="BSeeMoreLink" settings={props.settings.b7} />
					</LinkSeeAll>
					<LinkMoreMobile blockColorBackground={blockColorBackground}>
						<Box {...props} id="b7" type="BSeeMoreLink" settings={props.settings.b7} />
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M0.890625 5.01223L2.022 3.88086L7.99773 9.8566L13.9735 3.88086L15.1048 5.01223L7.99773 12.1193L0.890625 5.01223ZM13.9733 4.16387L14.8217 5.01227L7.9976 11.8364L7.99773 11.8365L14.822 5.01223L13.9735 4.1637L13.9733 4.16387ZM2.02183 4.16386L7.99744 10.1395L7.9976 10.1393L2.022 4.1637L2.02183 4.16386Z" />
						</svg>
					</LinkMoreMobile>
				</WrapperList>
			</Wrapper>
		</section>
	);
}

const WrapperList = styled("div", {
	position: "relative",
	".photo-on-left": {
		marginBottom: "16px"
	}
});

const WrapperTextOnPicture = styled("div", {
	".text-on-picture__title": {
		fontSize: "24px",
		fontWeight: 700,
		lineHeight: "32px",
		letterSpacing: "0.2px",
		"@bp4": {
			fontSize: "38px",
			fontWeight: 700,
			lineHeight: "50px"
		}
	}
});

const LinkMoreMobile = styled("div", {
	fontWeight: 600,
	fontSize: "18px",
	lineHeight: "24px",
	color: "#FF6400",
	borderTop: "1px solid rgba(255, 255, 255, 0.1)",
	paddingTop: "20px",
	width: "100%",
	textAlign: "center",
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	"&:hover": {
		color: "#E45A00",
		textDecoration: "none"
	},
	"&:active": {
		color: "#FF6400",
		textDecoration: "none"
	},
	"svg": {
		marginLeft: "9px",
		path: {
			fill:
				"$primary"
		}
	},
	"a": {
		color: "#fff"
	},
	"@bp4": {
		display: "none"
	},
	variants: {
		"blockColorBackground": {
			"#ffffff": {
				"a": {
					color: "$grayscale100Fixed"
				}
			}
		}
	}
});

const LinkSeeAll = styled("div", {
	display: "none",
	"@bp4": {
		display: "block",
		fontWeight: 600,
		fontSize: "16px",
		lineHeight: "24px",
		textDecoration: "underline",
		zIndex: 201,
		marginTop: "24px",
		a: {
			color: "#fff"
		}
	},
	"@bp5": {
		width: "408px"
	},
	variants: {
		"blockColorBackground": {
			"#ffffff": {
				"a": {
					color: "$grayscale100Fixed"
				}
			},
			"#131212": {
				"a:hover": {
					color: "#E45A00"
				}
			}
		}
	}
})